export const StepTypes = {
    AutomationTrigger: 'automationTrigger',
    UpdateRecord: 'updateRecord',
    WorkflowTrigger: 'workflowTrigger',
}
